import { Dialog, DialogContent, Stack, Box, DialogContentText, DialogActions, Button } from '@mui/material';
import { useMemo } from 'react';

export const FlowSwitchDialog = ({ open, onAgree, onCancel, flow }) => {
  const hasStepsInProgress = useMemo(() => flow?.steps.some((step) => step.completed), [flow]);
  const allStepsCompleted = useMemo(() => flow?.steps?.filter((s) => s.type === 'regular_step')?.every((step) => step.completed), [flow]);

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '400px',
          borderRadius: '13px',
          background: 'var(--White, #FFF)',
        },
      }}
    >
      <DialogContent
        dividers
        sx={{
          p: 3,
          border: 'none',
          position: 'relative',
        }}
      >
        <Stack spacing={2} sx={{ textAlign: 'center' }}>
          <img src="/alert-triangle.png" alt="alert-triangle" style={{ margin: 'auto' }} />

          <DialogContentText
            component={Box}
            sx={{
              '& > p': {
                fontWeight: 'bolder',
              },
            }}
          >
            {hasStepsInProgress
              ? 'It seems like you have progress in the new flow. Continue from where you left off or start from the beginning?'
              : 'By clicking ‘Switch’, you will switch to another flow. Your progress will be saved, allowing you to continue from where you left off.'}
          </DialogContentText>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction={hasStepsInProgress ? 'column' : 'row'} spacing={2} width="100%" paddingX={2} paddingBottom={2} justifyContent="center" alignItems="center">
          {hasStepsInProgress ? (
            <>
              {!allStepsCompleted && (
                <Button fullWidth variant="contained" color="info" onClick={() => onAgree(flow)} autoFocus sx={{ height: '46px' }}>
                  Switch and Continue
                </Button>
              )}
              <Button fullWidth variant="contained" color="info" onClick={() => onAgree({ ...flow, restart: true })} autoFocus sx={{ height: '46px' }}>
                Switch and Restart
              </Button>
              <Button fullWidth variant="outlined" color="info" onClick={onCancel} sx={{ height: '46px' }}>
                Cancel
              </Button>
            </>
          ) : (
            <>
              <Button fullWidth variant="outlined" color="info" onClick={onCancel} sx={{ height: '46px' }}>
                Cancel
              </Button>
              <Button fullWidth variant="contained" color="info" onClick={() => onAgree(flow)} autoFocus sx={{ height: '46px' }}>
                Switch
              </Button>
            </>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
